import React from "react"
import styled from "@emotion/styled"
import tw from "twin.macro"

import { withSearchHeaderSub } from "./withSearchHeaderSub"
import { SearchForm } from "../Form/SearchForm"
import { BackgroundContainer } from "../../Styled/Container"

const BgContainer = styled(BackgroundContainer)`
  ${tw`fixed z-20 left-0 top-0 bottom-0`}
  ${({ active }) => (active ? tw`opacity-100 pointer-events-auto` : tw`opacity-0 pointer-events-none`)}
`
const CloseLayer = styled.div`
  ${tw`absolute w-full h-full cursor-pointer z-0`}
  ${({ background }) => (background ? tw`bg-dark opacity-20` : tw`opacity-0`)}
`
const Container = styled.div`
  ${tw`fixed top-0 left-0 right-0 pt-10 z-40 px-0 hidden md:flex max-w-full flex-row w-full bg-light text-dark shadow-modal transition-all duration-slow`}
  ${({ active }) => (active ? tw`opacity-100 pointer-events-auto` : tw`opacity-0 pointer-events-none`)}
`
//z-40
const Wrapper = tw.div`w-full flex flex-col max-w-lg mx-auto justify-start md:px-1-6 pt-6 pb-10`
// const Title = tw.div`uppercase pb-3-2` // styledsmall

const SearchHeaderSub = withSearchHeaderSub(({ active, handleClickOverlay, location }) => {
  return (
    <BgContainer background={`transparent`} active={active}>
      <CloseLayer onClick={handleClickOverlay} background />
      <Container active={active}>
        <Wrapper>
          {/* <Title className="StyledSmall">{`Search`}</Title> */}
          <SearchForm location={location} componentId={`DesktopSearchForm`} />
        </Wrapper>
      </Container>
    </BgContainer>
  )
})

export default SearchHeaderSub
